import Desktop from ".";

import { activateFullStoryObserver, activateSmartlookClient, allowObserverScripts, checkFetchStatus, fillRoadmapText, initUserdata, restoreChipsFromSamePeriod, tempDataPage } from "@/modules/commonMobile";
import fillRoadmapFilters from "@/modules/fillRoadmapFilters";
import { getBasePcode, getBasePcodes, getGroupCode, getGroupDict, isMachineGame, isV2Game, machineGames } from "@/modules/gamePcode";
import { defaultNiuNiuResult } from "@/modules/virtualCards";
import { fetchApplyTickets, fetchTicketHistory, fillEmptyUnsubmittedTickets } from "@/modules/commonMachineGame";
import { fetchLanguageData } from "@/modules/locales";
import { setSettingProperties } from "@/modules/settings";
import { emitLobbyDisconnect, emitLobbyConnect } from "@/modules/sockets";
import { hideLoadingScreen } from "@/modules/loading";
import { fetchFavourites } from "@/modules/onlyLobbyMethods";

import { IGameObjectType, IGameType, IKeyNumberDict, IUserdataType } from "@/types/GlobalTypes";

const allowAssignRandomTimer = false;
const allowNewShoe = true;

function getGameListReq(useTempData: boolean) {
	return (useTempData) ?
		new Request(tempDataPage + "?page=games") :
		new Request("/games");
}

/**
 * for use in desktop & mobile lobby
 */
export function getFastTableGames(games: IGameObjectType) {
	return Object.keys(games).filter(pcode =>
		games[pcode].fast_table
	) ?? [];
}

/**
 * 
 * @param game Object reference to base game data
 */
function initGame(game: IGameType) {
	const { pcode } = game,
		basePcode = getBasePcode(game.pcode);

	game.active = false;
	game.totalBet = 0;
	game.totalWin = 0;
	game.lastSubmittedTotal = 0;

	if (game.roadmapFilters)
		game.activeRoadmapFilter = game.roadmapFilters[0];
	else game.roadmapFilters = [];

	game.betOutOfBounds = {};

	if (!allowNewShoe)
		game.newSet = false;

	// Reverse roadmap to make it look like creeping from the left
	switch (basePcode) {
		case "m24":
			game.niuNiuResult = defaultNiuNiuResult;
			break;
		default: break;
	}

	// Gives empty ticket array to machine games
	if (isMachineGame(pcode)) {
		game.tickets = []; // fetchGameList()
		game.activeUnsubmittedTicketRow = 0;
		fillEmptyUnsubmittedTickets(game);
	}

	if (/(m22|m23|m27|m28|m38)/.test(basePcode)
		// basePcode === "m22" ||
		// basePcode === "m23" ||
		// basePcode === "m27" ||
		// basePcode === "m28" ||
		// basePcode === "m38"
	) {
		game.pushedBigRoad = false;
	}

	game.transparentChips = false;
}

/**
 * Fetch all game collectively, updates state.games.
 */
function fetchGameList(this: Desktop, paramObj: { firstTime?: boolean, games?: IGameObjectType, pcode?: string }) {
	const lobby = this;

	const request = getGameListReq(this.state.useTempData);
	console.log("request",request);

	let init: RequestInit;
	if (!this.state.useTempData) {
		init = { credentials: "same-origin" };
	}

	fetch(request, init)
		.then((res: any) => res.json())
		.then((games: IGameObjectType) => {
			console.log("test",games);
			if (!this.state.useTempData)
				checkFetchStatus(games);

			this.defaultHowToPlayPcode = Object.keys(games)[0];

			// Fetch game list for the first time
			if (!paramObj.games) {
				fillRoadmapFilters(games);

				const
					gamePcodes = Object.keys(games),

					uniqueGamePcodes = getBasePcodes(gamePcodes),
					gameGroups = getGroupDict(gamePcodes);

				// console.log("Unique pcodes: ", uniqueGamePcodes);
				// console.log("Groups: ", gameGroups);

				const fastTableGames = getFastTableGames(games);

				// console.log("Fast table games", fastTableGames.join(", "));

				// Init modal and roadmap
				for (const pcode in games) {
					const game = games[pcode];

					initGame(games[pcode]);

					this.checkController(game); // fetchGameList

					const basePcode = getBasePcode(pcode);

					// Socket event suppressor
					if (isV2Game(basePcode) ||
						isMachineGame(basePcode))
						this.prevScanValue[pcode] = {};
				}

				// Fetches ticket history from the previous period
				window.setTimeout(() => {
					machineGames.forEach(pcode => {
						const game = games[pcode];

						if (!game) return;

						fetchApplyTickets(lobby, game, () => {
							lobby.setState({ games });
						});
					});
				}, 100);

				if (paramObj.firstTime)
					this.fetchGameTime(games);

				// Copied from LobbyMobile
				// Sets activeGame (since there's no activeGame here
				const gameArray = Object.keys(games);
				this.activePcode = gameArray[gameArray.length - 1];

				this.setState({
					// For PopupResultHistory
					activeGame: games[gameArray[gameArray.length - 1]],

					games,

					uniqueGamePcodes,
					gameGroups,
					fastTableGames,
				}, () => {
					lobby.setLobbyGameFilter();

					lobby.closeAllGames();

					lobby.fetchGameHistory();

					// Checks game object for games with tickets
					Object.keys(lobby.state.games).forEach(pcode => {
						const basePcode = getBasePcode(pcode);
						const machineGame = isMachineGame(basePcode);

						// fills lastPeriodTickets & disableRebet
						if (machineGame)
							fetchTicketHistory(lobby, pcode, lobby.state.games[pcode].periode);
					});

					// Fetches transaction history
					lobby.fetchTransactionHistory(null);
					lobby.allowRefetchTransaction = true;
				});
			} else {
				// Updates active game's period
				paramObj.games[paramObj.pcode].periode = games[paramObj.pcode].periode;

				// Reverse big_road for Baccarat only
				if (getBasePcode(paramObj.pcode) === "m22" || getBasePcode(paramObj.pcode) === "m38")
					paramObj.games[paramObj.pcode].roadmap.big_road = games[paramObj.pcode].roadmap.big_road.reverse();

				this.setState({ games: paramObj.games });
			}
		})
		.catch(error =>
			// alert("Failed to fetch game list, please try again later.");
			console.error("Failed to fetch game list", error)
		);
}

/**
	 * Fetches game time collectively.
	 * @param gamedata The game object reference to fill with the timer data.
	 */
function fetchGameTime(this: Desktop, gamedata: IGameObjectType) {
	if (allowAssignRandomTimer) {
		// Always paired with useTempData

		console.warn("allowAssignRandomTimer is on, the timers will be set randomly.");

		//Copy gamedata into games
		const games = JSON.parse(JSON.stringify(gamedata));

		// fills games with random time
		let t = 0;
		for (const a in games) {
			t = Math.round(Math.random() * 10);
			games[a] = { time: t, timer: 60 };
		}

		this.setState({
			timers: games,
			// games: games
		});
	} else {
		// Set 0 for all timers

		const games = JSON.parse(JSON.stringify(gamedata));

		for (const a in games) {
			// Test time toto macau in local
			games[a] = (a === "m17") ? { time: 0, timer: 6000 } : { time: 0, timer: 60 };
		}

		this.setState({
			timers: games
		});
	}

	if (this.state.useTempData) {
		const lobby = this;
		// console.log("fGT l s eT", enableTimers);

		if (!this.timerTimer && !this.addedTimers)
			this.timerTimer = window.setTimeout(() => {
				// Init timers
				if (this.state.enableTimers) {
					lobby.intervalUserData = window.setInterval(() => lobby.fetchUserData(null), 45000);
					lobby.intervalGameTime = window.setInterval(() => { lobby.updateGameTimers(); }, 1000);

					lobby.addedTimers = true;
				}
			}, 1000);

		return;
	}

	if (allowAssignRandomTimer) return;

	fetch("/games/timer", {
		credentials: "same-origin",
		method: "GET",
	})
		.then(res => res.json())
		.then((data: any) => {
			console.debug("fGT()", data);

			for (const pcode in data)
				data[pcode].time = (
					isNaN(data[pcode].time) ? 0 : Number(data[pcode].time)
				);

			this.setState({ timers: data });

			const lobby = this;
			// console.log("fGT l s eT", enableTimers);

			if (!this.timerTimer)
				this.timerTimer = window.setTimeout(() => {
					// Init timers
					if (this.state.enableTimers) {
						lobby.intervalUserData = window.setInterval(() => lobby.fetchUserData(null), 45000);
						lobby.intervalGameTime = window.setInterval(() => { lobby.updateGameTimers(); }, 1000);
					}
				}, 1000, () => console.log("Empty callback"));
		});
}


/**
 * Fetches sound volumes
 */
function fetchSoundVolumes(this: Desktop) {
	const request = (this.state.useTempData) ?
		new Request(tempDataPage + "?page=setting-volume") :
		new Request("/auth/setting-volume");

	let init: RequestInit;
	if (!this.state.useTempData)
		init = {
			credentials: "same-origin",
			method: "GET",
		};

	fetch(request, init)
		.then((res: any) => res.json())
		.catch(error => {
			this.setState({ showErrorPage: true, errorType: "lostauth", errorMessage: "" });
			return console.error(error);
		})
		.then((data: any) => {
			this.setState({
				musicVolume: isNaN(data.volumeMusic) ? 50 : (Number(data.volumeMusic) * 100),
				soundVolume: isNaN(data.volumeSound) ? 50 : (Number(data.volumeSound) * 100)
			});
		});
}


// Fetches user data
// paramObj: the parameter JSON
// 		firstTime: if the user loads for the first time
// fetchUserData()
function fetchUserData(this: Desktop, paramObj: any) {
	const request = (this.state.useTempData) ?
		new Request(tempDataPage + "?page=userdata") :
		new Request("/auth/datapost");

	let init: RequestInit;
	if (!this.state.useTempData)
		init = {
			credentials: "same-origin",
			method: "POST", // POST
			body: JSON.stringify({ test: "this is a test" })
		};

	// Fetch user data
	fetch(request, init)
		.then(res => res.json())
		.catch(error => {
			this.setState({ showErrorPage: true, errorType: "lostauth", errorMessage: "" });
			return console.error(error);
		})
		.then((userdata: IUserdataType) => {
			if (!this.state.useTempData)
				checkFetchStatus(userdata);

			initUserdata(userdata);
			console.log("initUserdata")
			console.log(userdata)

			// initialises Socket IO
			if (!this.socketio) {
				this.initSocketIO(userdata);
			}

			// maingame check, activates the game according to maingame
			if (!this.hasLoadedMainGame)
				if (userdata.user.maingame &&
					userdata.user.maingame.trim() !== "" &&
					userdata.user.device !== "phone") {
					let renderAttempts = 1;
					this.hasLoadedMainGame = true;

					const thisLobby = this

					this.intervalRenderMainGame = window.setInterval(function () {
						renderAttempts = thisLobby.attemptRenderMainGame(userdata, renderAttempts)
					}, 200);
				}

			// Only performs on the first load
			if (paramObj && paramObj.firstTime) {
				//Activates smartlook for testing
				//User agent "wskaa" (891623504)
				if (allowObserverScripts(userdata)) {
					activateSmartlookClient();
					activateFullStoryObserver(userdata);
				}

				// Automatically uses fallback language
				const lang = userdata.user.lang || "en";

				// Fetches language data
				fetchLanguageData(this, lang);

				// Fetches favourited games
				fetchFavourites(this);

				// Sets setting properties
				setSettingProperties(this, userdata);

				//Applies roadmap contents
				this.applyRoadmapAttempts = 1;
				this.applyRoadmapTimer = window.setInterval(() => {
					const { games } = this.state;

					if (!games ||
						Object.keys(games).length === 0) {
						this.applyRoadmapAttempts++;

						if (this.applyRoadmapAttempts > 20) {
							window.clearInterval(this.applyRoadmapTimer);
							console.error("Timeout exceeds 60000 milliseconds");
						}
					} else {
						//Chip restoration
						restoreChipsFromSamePeriod(this);

						fillRoadmapText(games, this.state.lang);

						this.setState({
							games: games,
							chipValue: Number(userdata.user.chipBase[0])
						});

						// Checks lobby.state.games
						window.clearInterval(this.applyRoadmapTimer);

						// Hides the loading screen
						hideLoadingScreen();
					}
				}, 3000);

				// Fetch sound volume settings
				this.fetchSoundVolumes();

				// Emits to server to count the active users
				if (!this.state.useTempData)
					window.onbeforeunload = () => {
						// e.preventDefault();

						emitLobbyDisconnect(this, this.state.userdata);
					};
			}

			this.setState({ userdata: userdata });

			if (!this.hasEmittedLobbyConnect)
				emitLobbyConnect(this, userdata);
		});
}

export {
	fetchGameList,
	fetchGameTime,
	fetchSoundVolumes,
	fetchUserData
}
